import React, { useState } from 'react';
import './Login.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = ({ onLogin }) => {
  const [isAdmin, setIsAdmin] = useState(false); // toggle between user/admin
  const [isRegistering, setIsRegistering] = useState(false); // toggle between login/signup
  const [formData, setFormData] = useState({ name: '', email: '', password: '' });
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleToggle = () => {
    setIsAdmin(!isAdmin);
    setIsRegistering(false);
    setMessage('');
    setFormData({ name: '', email: '', password: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      if (isAdmin) {
        // Admin login
        const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/admin/login`, {
          email: formData.email,
          password: formData.password,
        });

        const adminToken = res.data.token;
        localStorage.setItem('adminToken', adminToken);
        setMessage('✅ Admin login successful! Redirecting...');
        window.dispatchEvent(new Event('user-logged-in'));
        setTimeout(() => {
          window.dispatchEvent(new Event('user-logged-in'));
          navigate('/admin/dashboard');
        }, 1000);
      } else if (isRegistering) {
        // User Sign Up
        const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/register`, {
          name: formData.name,
          email: formData.email,
          password: formData.password,
        });

        const { token, user } = res.data;
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
        window.dispatchEvent(new Event('user-logged-in'));

        setMessage('✅ Sign up successful! Redirecting...');
        if (onLogin) onLogin(user);

        setTimeout(() => {
          window.dispatchEvent(new Event('user-logged-in'));

          navigate('/');
        }, 1000);
      } else {
        // User login
        const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, {
          email: formData.email.toLowerCase(),
          password: formData.password,
        });

        const user = res.data.user;
        const token = res.data.token;
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('token', token);
        window.dispatchEvent(new Event('user-logged-in'));

        setMessage('✅ Login successful! Redirecting...');
        if (onLogin) onLogin(user);

        setTimeout(() => {
          window.dispatchEvent(new Event('user-logged-in'));

          navigate('/');
        }, 1000);
      }
    } catch (err) {
      console.error(err);
      if (err.response?.data?.message?.includes('exists')) {
        setMessage('❌ User already exists with this email.');
      } else {
        setMessage('❌ Operation failed. Check credentials or try again.');
      }
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '1rem' }}>
          <span
            style={{ cursor: 'pointer', fontWeight: !isAdmin ? 'bold' : 'normal' }}
            onClick={() => handleToggle()}
          >
            User {isRegistering ? 'Sign Up' : 'Login'}
          </span>
          |
          <span
            style={{ cursor: 'pointer', fontWeight: isAdmin ? 'bold' : 'normal' }}
            onClick={() => setIsAdmin(true)}
          >
            Admin Login
          </span>
        </div>

        <h2 className="login-title">
          {isAdmin ? 'Admin Login' : isRegistering ? 'User Sign Up' : 'User Login'}
        </h2>

        {!isAdmin && isRegistering && (
          <>
            <label htmlFor="name">Name</label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </>
        )}

        <label htmlFor="email">Email</label>
        <input
          type="email"
          name="email"
          id="email"
          placeholder="Enter your email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label htmlFor="password">Password</label>
        <input
          type="password"
          name="password"
          id="password"
          placeholder="Enter your password"
          value={formData.password}
          onChange={handleChange}
          required
        />

        <button type="submit">{isRegistering ? 'Sign Up' : 'Login'}</button>

        {/* Small toggle button for User only */}
        {!isAdmin && (
          <button
            type="button"
            onClick={() => setIsRegistering(!isRegistering)}
            style={{
              marginTop: '8px',
              fontSize: '0.85rem',
              background: 'none',
              border: 'none',
              color: '#007bff',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
          >
            {isRegistering ? 'Already have an account? Login' : "Don't have an account? Sign up"}
          </button>
        )}

        {message && <p style={{ marginTop: '1rem', color: '#555' }}>{message}</p>}
      </form>
    </div>
  );
};

export default Login;
